// The edit landing page: it presents the embed script. In edit mode, the page loads the embed
// script (`own-embed.ts`), thus the page is its own demo.
import "./analytics";
import "./own-embed";
import { showAccount } from "./account";
import { $ } from "./dom";

// The parameter is "edit", or the edit key after `own-embed.ts` changes it.
const editMode = new URLSearchParams(location.search).has("feedmark");
$("try").hidden = editMode;
$("edit-on").hidden = !editMode;

showAccount();
